export const preventReloadOrLeavePage = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  return 'Unsaved changes';
};
